import { getMMT_HLD_OBJ } from '../../../common/utils/appUtils';
import {
  dateFormatter,
  formatURLDate,
  isAgentLoggedIn,
  isValidDate,
} from '../../../common/utils/browserUtils';
import { getRoomFromParams } from '../../../common/utils/formattingUtils';
import {
  getAllUrlParams,
  getReqDataSsr,
  getCriterias,
  getSortersCriterias,
} from '../../helpers/utils';
import {
  CLEAR_ALL_PACKAGES,
  SET_INITIAL_DATA_LOADED,
  SET_LISTING_PACKAGES,
  SET_LISTING_PACKAGES_IS_LOADING,
  SET_PAGE_LOADING,
} from '../constants/listingPackagesConstants';
import { getListingPackages } from '../services/listingPackages';

const isAgentLogged = isAgentLoggedIn();

export const getInitialPackagesAction = requestParam => async (dispatch, getState) => {
  const { groupMetadata, metadata } = getState();
  // eslint-disable-next-line no-undef
  const urlParams = ssr.isOnClient ? getAllUrlParams() : getReqDataSsr(requestParam);
  const { fromCityCode, dest, depCity = 'New Delhi', packageIds, rooms, cmp, campaign } = urlParams;
  const firstGroupCriterias = groupMetadata?.groupDetailsList?.[0]?.criterias || [];
  const firstGroupId = groupMetadata?.groupDetailsList?.[0]?.id || 'listing';

  const listingFilters = metadata?.listingFilters;
  const listingSorters = metadata?.listingSorters;
  const filterCriterias = getCriterias(listingFilters);
  const sorterCriterias = getSortersCriterias(listingSorters);
  const searchText = isAgentLogged ? urlParams?.searchText : '';

  dispatch({
    type: SET_LISTING_PACKAGES_IS_LOADING,
    payload: { [firstGroupId]: true },
  });
  try {
    const params = {
      departureCity: depCity,
      destinationCity: dest,
      offset: 0,
      criterias: [...firstGroupCriterias, ...filterCriterias],
      sorterCriterias,
      apiPokus: getMMT_HLD_OBJ()?.apiPokusListing,
      searchText,
    };

    if (typeof +firstGroupId === 'number' && !isNaN(+firstGroupId)) {
      params.groupId = firstGroupId;
    }

    if (fromCityCode) {
      params.departureLocusCode = fromCityCode;
    }

    if (packageIds) {
      params.packageIds = packageIds.split(',');
    }

    if (isValidDate(urlParams?.dateSearched)) {
      params.packageDate = dateFormatter(formatURLDate(urlParams?.dateSearched), 'YYYY-MM-DD');
    }

    if (rooms) {
      params.rooms = getRoomFromParams(rooms);
    }

    if (cmp) {
      params.cmp = cmp;
    }

    if (campaign) {
      params.campaign = campaign;
    }

    const response = await getListingPackages(params);
    if (response?.data?.success) {
      const { packageDetails, noMorePackages, nextOffset, numFound, errorMessage } =
        response?.data || {};
      dispatch({
        type: SET_LISTING_PACKAGES,
        payload: {
          groupId: firstGroupId,
          packageDetails,
          noMorePackages,
          nextOffset,
          numFound,
          errorMessage,
        },
      });
    } else {
      // error state
      dispatch({
        type: SET_LISTING_PACKAGES,
        payload: { groupId: firstGroupId, packageDetails: [], noMorePackages: true },
      });
    }
    dispatch({
      type: SET_LISTING_PACKAGES_IS_LOADING,
      payload: { [firstGroupId]: false },
    });
  } catch (e) {
    dispatch({
      type: SET_LISTING_PACKAGES_IS_LOADING,
      payload: { [firstGroupId]: false },
    });
  }
};

export const getPackagesAction =
  ({ groupId, offset = 0 }) =>
  async (dispatch, getState) => {
    const { metadata, groupMetadata } = getState();
    const urlParams = getAllUrlParams();
    const { fromCityCode, dest, depCity = 'New Delhi', packageIds, campaign, rooms } = urlParams;
    const groupList = groupMetadata?.groupDetailsList;
    const group = groupList?.find(groupObj => groupObj?.id === groupId) || {};
    const groupCriterias = group?.criterias || [];
    const listingFilters = metadata?.listingFilters;
    const listingSorters = metadata?.listingSorters;
    const filterCriterias = getCriterias(listingFilters);
    const sorterCriterias = getSortersCriterias(listingSorters);
    const searchText = isAgentLogged ? urlParams?.searchText : '';
    dispatch({
      type: SET_LISTING_PACKAGES_IS_LOADING,
      payload: { [groupId]: true },
    });
    try {
      const params = {
        departureCity: depCity,
        destinationCity: dest,
        offset: offset || 0,
        criterias: [...groupCriterias, ...filterCriterias],
        sorterCriterias,
        apiPokus: getMMT_HLD_OBJ()?.apiPokusListing,
        searchText,
      };

      if (typeof +groupId === 'number' && !isNaN(+groupId)) {
        params.groupId = groupId;
      }

      if (packageIds) {
        params.packageIds = packageIds.split(',');
      }

      if (fromCityCode) {
        params.departureLocusCode = fromCityCode;
      }

      if (rooms) {
        params.rooms = getRoomFromParams(rooms);
      }

      if (campaign) {
        params.campaign = campaign;
      }

      if (isValidDate(urlParams?.dateSearched)) {
        params.packageDate = dateFormatter(formatURLDate(urlParams?.dateSearched), 'YYYY-MM-DD');
      }

      const response = await getListingPackages(params);
      if (response?.data?.success) {
        const { packageDetails, noMorePackages, nextOffset, numFound, errorMessage } =
          response?.data || {};
        dispatch({
          type: SET_LISTING_PACKAGES,
          payload: {
            groupId,
            packageDetails,
            noMorePackages,
            nextOffset,
            numFound,
            errorMessage,
          },
        });
      } else {
        dispatch({
          type: SET_LISTING_PACKAGES,
          payload: { groupId, packageDetails: [], noMorePackages: true },
        });
      }
      dispatch({
        type: SET_LISTING_PACKAGES_IS_LOADING,
        payload: { [groupId]: false },
      });
    } catch (e) {
      dispatch({
        type: SET_LISTING_PACKAGES_IS_LOADING,
        payload: { [groupId]: false },
      });
    }
  };

export const setInitialDataLoadedAction = () => ({
  type: SET_INITIAL_DATA_LOADED,
});

export const clearAllPackagesAction = () => ({
  type: CLEAR_ALL_PACKAGES,
});

export const pageLoadingAction = (payload = true) => ({
  type: SET_PAGE_LOADING,
  payload,
});
